import React from 'react'
import {TabsNavigation as PepsicoDsTabsNavigation} from 'pepsico-ds'

/**
 * TabsNavigation component that renders a PepsicoDsTabsNavigation with properties from props.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.tabList - The list of tabs to display.
 * @param {boolean} [props.isDarkTab=true] - Optional boolean to indicate dark mode styling for the tabs.
 * @param {number} props.activeTabIndex - The index of the currently active tab.
 * @param {Function} props.handleSetActiveTab - The function to handle tab change events.
 * @param {ReactNode} props.children - The tabs to display as children.

 * @returns {JSX.Element} The rendered TabsNavigation component.
 */

const TabsNavigation = ({handleSetActiveTab, activeTabIndex, className, children}) => {
  return (
    <PepsicoDsTabsNavigation onUpdate={handleSetActiveTab} selectedIndex={activeTabIndex} className={className}>
      {children}
    </PepsicoDsTabsNavigation>
  )
}

export default TabsNavigation
